@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.status" (toggleVisibility)="toggleShow()" [visible]="isVisible" [hasValues]="isDirty()" aid="filterStatus">
    <div class="planeringsstatus-panel">
      <div class="dummy-component-for-header">
        <fieldset>
          <label>
            {{texts.planeringsstatus}}
          </label>
        </fieldset>
      </div>
      <div class="planeringsstatus-panel-items">
        <rask-checkbox aid="filterStatusUnderplanering" [text]="texts.underplanering" [ngModel]="hasCheckedValue(searchFilter.status.planeringsstatus.underPlanering)" (change)="searchFilter.status.planeringsstatus.underPlanering = $event"></rask-checkbox>
        <rask-checkbox aid="filterStatusFardigplanerad" [text]="texts.fardigplanerad" [ngModel]="hasCheckedValue(searchFilter.status.planeringsstatus.fardigplanerad)" (change)="searchFilter.status.planeringsstatus.fardigplanerad = $event"></rask-checkbox>
        <rask-checkbox aid="filterStatusTillganglig" [text]="texts.tillganglig" [ngModel]="hasCheckedValue(searchFilter.status.planeringsstatus.tillganglig)" (change)="searchFilter.status.planeringsstatus.tillganglig = $event"></rask-checkbox>
      </div>
    </div>
    <div class="produktionsstatus-panel">
      <div class="dummy-component-for-header">
        <fieldset>
          <label>
            {{texts.produktionsstatus}}
          </label>
        </fieldset>
      </div>
      <div class="planeringsstatus-panel-items">
        <rask-checkbox aid="filterStatusProduktionEjPaborjad" [text]="texts.produktionEjPaborjad" [ngModel]="hasProduktionsstatusValue(produktionsstatus.ProduktionEjPaborjad)" (change)="toggleProduktionsstatusValue(produktionsstatus.ProduktionEjPaborjad, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusProduktionPagar" [text]="texts.produktionPagar" [ngModel]="hasProduktionsstatusValue(produktionsstatus.ProduktionPagar)" (change)="toggleProduktionsstatusValue(produktionsstatus.ProduktionPagar, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusProduktionAvslutad" [text]="texts.produktionAvslutad" [ngModel]="hasProduktionsstatusValue(produktionsstatus.ProduktionAvslutad)" (change)="toggleProduktionsstatusValue(produktionsstatus.ProduktionAvslutad, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusProduktionSlutrapporterad"
          [text]="texts.produktionSlutrapporterad"
          [ngModel]="hasProduktionsstatusValue(produktionsstatus.Slutrapporterad)"
          (change)="toggleProduktionsstatusValue(produktionsstatus.Slutrapporterad, $event)">
        </rask-checkbox>
      </div>
    </div>
    <div class="virkesorderstatus-panel">
      <div class="dummy-component-for-header">
        <fieldset>
          <label>
            {{texts.virkesorderstatus}}
          </label>
        </fieldset>
      </div>
      <div class="virkesorderstatus-panel-items">
        <rask-checkbox aid="filterStatusVirkesorderSand" [text]="texts.virkesorderStatus.sand" [ngModel]="hasVirkesorderstatusValue(virkesorderstatus.Sand)" (change)="toggleVirkesorderstatusValue(virkesorderstatus.Sand, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusVirkesorderAktiv" [text]="texts.virkesorderStatus.aktiv" [ngModel]="hasVirkesorderstatusValue(virkesorderstatus.Aktiv)" (change)="toggleVirkesorderstatusValue(virkesorderstatus.Aktiv, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusVirkesorderFel" [text]="texts.virkesorderStatus.fel" [ngModel]="hasVirkesorderstatusValue(virkesorderstatus.FelLoadTender)" (change)="toggleVirkesorderstatusValue(virkesorderstatus.FelLoadTender, $event)"></rask-checkbox>
        <rask-checkbox aid="filterStatusVirkesorderAvslutad" [text]="texts.virkesorderStatus.avslutad" [ngModel]="hasVirkesorderstatusValue(virkesorderstatus.Makulerad)" (change)="toggleVirkesorderstatusValue(virkesorderstatus.Makulerad, $event)"></rask-checkbox>
      </div>
    </div>
    <div class="virkesorderstatus-panel">
      <div class="dummy-component-for-header">
        <fieldset>
          <label>
            {{texts.virkesordersyncstatus}}
          </label>
        </fieldset>
      </div>
      <div class="virkesorderstatus-panel-items">
        <rask-checkbox aid="filterStatusVirkesorderUppdateras" [text]="texts.virkesorderStatus.uppdateringKravs" [ngModel]="hasCheckedValue(searchFilter.status.voBehoverUppdateras)" (change)="searchFilter.status.voBehoverUppdateras = $event"></rask-checkbox>
      </div>
    </div>
  </rask-arbetsorder-search-filter>
}
